//
// Original collection by Kjetil Midtgarden Golid
// https://github.com/kgolid/chromotome
// https://kgolid.github.io/chromotome-site/
//
export default [
  {
    name: 'iiso_zeitung',
    colors: ['#ee8067', '#f3df76', '#00a9c0', '#f7ab76'],
    stroke: '#111a17',
    background: '#f5efcb',
    type: 'iivonen',
  },
  {
    name: 'iiso_curcuit',
    colors: ['#f0865c', '#f2b07b', '#6bc4d2', '#1a3643'],
    stroke: '#0f1417',
    background: '#f0f0e8',
    type: 'iivonen',
  },
  {
    name: 'iiso_airlines',
    colors: ['#fe765a', '#ffb468', '#4b588f', '#faf1e0'],
    stroke: '#1c1616',
    background: '#fae5c8',
    type: 'iivonen',
  },
  {
    name: 'iiso_daily',
    colors: ['#e76c4a', '#f0d967', '#7f8cb6', '#1daeb1', '#ef9640'],
    stroke: '#000100',
    background: '#e2ded2',
    type: 'iivonen',
  },
];
